import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import Header from "./Header";
import CollegeList from "./CollegeList";
import ExamDeadlines from "./ExamDeadlines";
import UpcomingEvents from "./UpcomingEvents";
import DcpInsight from "./DcpInsight";
import CurrentPlan from "./CurrentPlan";
import RecentActivites from "./RecentActivities";
import ParentAccess from "./ParentAccess";
import Calendar from "./Calendar";
import CompleteProfile from "./CompleteProfile";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { getDashboardColleges, getWishListCollege } from "../../api/collegeApi";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [addOpen, setAddOpen] = useState(false);
  const [aiColleges, setAiColleges] = useState([]);
  const [colleges, setWishListCollege] = useState([]);

  const getAllWishListColleges = async () => {
    try {
      dispatch(setLoading({
        loading: true
      }));
      const response = await getWishListCollege(user?.student_id);
      const aiColleges = await getDashboardColleges(user?.student_id);
      setAiColleges(aiColleges.data);
      if (response.data.length > 0) {
        setWishListCollege(response.data);
      } else {
        setWishListCollege([]);
      }
      dispatch(setLoading({
        loading: false
      }));
    } catch (err) {
      setWishListCollege([]);
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      showNotification(errorMessage, 'error');
      dispatch(setLoading({
        loading: false
      }));
    }
  };

  useEffect(() => {
    if (user?.students_completed_profile_percentage < 100 && !localStorage.getItem('permenentclose')) {
      setAddOpen(true);
    }
    if (user?.student_id) {
      getAllWishListColleges();
    }
  }, [user?.user_id]);

  return (
    <Box
      sx={{
        height: '85vh',
        overflow: 'auto'
      }}
    >
      <Grid container spacing={2}>
        <CompleteProfile
          addOpen={addOpen}
          setAddOpen={setAddOpen}
        />
        <Header colleges={colleges}/>
        <CollegeList colleges={colleges} aiColleges={aiColleges} />
        <Grid item md={8} xs={12}>
          <ExamDeadlines />
          <UpcomingEvents />
          <DcpInsight />
        </Grid>
        <Grid item md={4} xs={12}>
          <CurrentPlan />
          <RecentActivites />
          <ParentAccess />
          <Calendar />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;